import React, { useEffect, useRef, useState } from 'react';
import './CustomerStories.css';

const CustomerStories = () => {
  const scrollContainerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile view
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Auto-scroll functionality for mobile
  useEffect(() => {
    if (!isMobile || !scrollContainerRef.current) return;

    const container = scrollContainerRef.current;
    const cardWidth = container.firstChild?.offsetWidth || 0;
    const gap = 12;
    const scrollStep = cardWidth + gap;
    const totalCards = 4;
    let currentIndex = 0;

    const autoScroll = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalCards;
      const scrollPosition = currentIndex * scrollStep;

      // If we've scrolled to the end, reset to beginning
      if (scrollPosition >= container.scrollWidth - container.clientWidth) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
        currentIndex = 0;
      } else {
        container.scrollTo({ left: scrollPosition, behavior: 'smooth' });
      }
    }, 3000);

    return () => clearInterval(autoScroll);
  }, [isMobile]);

  const testimonials = [
    {
      id: 1,
      type: 'text',
      bgColor: '#b3e5fc',
      quote: 'ABHI is my companion for good health',
      quoteColor: '#01579b',
      name: 'Arun Sharma',
      company: 'We Care Finserv',
      location: '',
      hasVideo: false
    },
    {
      id: 2,
      type: 'text',
      bgColor: '#ffd54f',
      quote: 'My trading experience with ABM has been very fruitful. I have always been receiving excellent support from my dealer. Moreover, the transparent business practices at ABM makes it the preferred broker in the industry.',
      quoteColor: '#333',
      name: 'Mrs. Priyanka Sharma',
      company: 'We Care Finserv',
      location: '',
      hasVideo: false
    },
    {
      id: 3,
      type: 'text',
      bgColor: '#ffccbc',
      quote: 'Their communication is very prompt and staff is veryresourceful.',
      quoteColor: '#bf360c',
      name: 'Ashesh Shah',
      company: 'We Care Finserv',
      location: '',
      hasVideo: false
    },
    {
      id: 4,
      type: 'text',
      bgColor: '#8bc34a',
      quote: 'We Care Finserv has been my companion in my weight loss journey of losing 15 Kgs and helping me stay disease-free. Health Returns keeps my whole family motivated to be active and stay fit and each person can do the exercise of their choice',
      quoteColor: '#2d5016',
      name: 'Mr. Rajinder Balhara',
      company: 'We Care Finserv',
      location: '',
      hasVideo: false
    }
  ];

  return (
    <section className="customer-stories">
      <div className="stories-container">
        <div className="stories-header">
          <h2 className="stories-title">
            Customer Satisfaction <span className="title-highlight">Stories</span>
          </h2>
          <p className="stories-subtitle">
            Don't just take our word for it. Here's what our customers have to say about their successful financial journeys
          </p>
        </div>

        <div className="testimonials-grid" ref={scrollContainerRef}>
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className={`testimonial-card ${testimonial.type}`}
              style={{ backgroundColor: testimonial.bgColor }}
            >


              <div className="card-content">
                <div className="quote-section">
                  <div className="quote-mark open">"</div>
                  <p className="testimonial-quote" style={{ color: testimonial.quoteColor }}>
                    {testimonial.quote}
                  </p>
                  <div className="quote-mark close">"</div>
                </div>

                <div className="customer-info">
                  <div className="customer-avatar">
                    <div className="avatar-circle">
                      <svg width="40" height="40" viewBox="0 0 40 40">
                        <circle cx="20" cy="20" r="18" fill={testimonial.type === 'video' ? 'white' : '#666'} opacity="0.3" />
                        <path d="M20 10 C 15 10, 12 13, 12 17 C 12 21, 15 23, 20 23 C 25 23, 28 21, 28 17 C 28 13, 25 10, 20 10 M 20 25 C 13 25, 8 28, 8 32 L 32 32 C 32 28, 27 25, 20 25" fill={testimonial.type === 'video' ? 'white' : '#666'} />
                      </svg>
                    </div>
                  </div>
                  <div className="customer-details">
                    <h4 className="customer-name" style={{ color: testimonial.type === 'video' ? 'white' : '#333' }}>
                      {testimonial.name}
                    </h4>
                    <p className="customer-company" style={{ color: testimonial.type === 'video' ? 'rgba(255,255,255,0.8)' : '#666' }}>
                      {testimonial.company}
                    </p>
                    {testimonial.location && (
                      <p className="customer-location" style={{ color: testimonial.type === 'video' ? 'rgba(255,255,255,0.8)' : '#666' }}>
                        <span className="location-icon">📍</span> {testimonial.location}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerStories;
